<template>
<div ref="ShopFollow">    
    <div class="shop-follow-info top20">
        <wcimage :option="{size:'middle'}" :value="param.logo" />
        <span class="shop-names">{{param.shopname}}</span>
        <span class="shop-level">({{param.levelname}})</span>
        <wcbutton :option="{title:'提交数据'}" @finish="submit()" class="left20" />
    </div>

    <!-- 表单提交 -->
    <div class="top20">
        <el-form :inline="false">
            <el-form-item>
                <label class="TTL-form-label">跟进时间<i>* </i></label>
                <wctime :option="{placeholder:'请选择跟进时间',clearable:true,type:'date',width:'220px',ischange:true}"
                    :value="param.followtime"
                    @finish="(val)=> {
                        param.followtime=val.value;
                    }"
                />
            </el-form-item>
            <el-form-item>
                <label class="TTL-form-label">跟进类型<i>* </i></label>
                <wcselect :option="{placeholder:'请选择记录类型',clearable:true,filterable:true,width:'220px',ischange:true}"
                    :value="param.typeid"
                    :list="typelist"
                    @finish="(val)=> {
                        if(val.type=='change') {
                            param.typeid=val.value;
                            param.typename=val.valuename;
                        }
                    }"
                />
            </el-form-item>
            <el-form-item>
                <label class="TTL-form-label">跟进内容<i>* </i></label>
                <div class="TTL-input">
                <el-input type="textarea" v-model="param.description" class="width350" :autosize="{ minRows: 3, maxRows: 4}" />
                </div>
            </el-form-item>
            <el-form-item>
                <label class="TTL-form-label">跟进图片</label>
                <wcuploadmore :option="{type:'select',width:'60%', phototype:'system'}" :value="param.files"
                    @finish="(val)=> {GetFileImges(val.url)}"
                />
            </el-form-item>
        </el-form>
    </div>


    <!-- 跟进记录 -->
    <div class="shop-follow-log" id="table-shopfollow-obj">
        <div class="shop-follow-log-info" v-for="(item,index) in loglist" :key="index">
            <i class="log-cover"></i>
            <span class="shop-follow-times">{{item.followtime}}（{{item.managername}}）<i>{{item.typename}}</i></span>
            <span class="shop-follow-content">{{item.description}}</span>
            <div class="shop-follow-files">
                <wcimage :option="{size:'small'}" :value="file.url" :list="item.filelist" v-for="(file,i) in item.files" :key="i" />
            </div>
        </div>
    </div>

    
</div>
</template>

<script>
import INTERFACE_MODEL_SHOP from '@/Interface/Shop/index';
import INTERFACE_MODEL_BASE from '@/Interface/index';
export default {
    components:{},
    data() {
        return {
            param: {
                shopid:'',
                shopname:'',
                logo:'',
                levelname:'',
                typeid:'',
                typename:'',
                description:'',
                followtime:'',
                files:[],
            },
            typelist:[
                {id:1,name:'跟进'},
                {id:2,name:'回访'},
                {id:3,name:'闲聊'},
            ],
            loglist:[],
        }
    },
    mounted() {
        this.OnloadMethod(); //页数初始化
    },
    methods: {

        /** 页数初始化 **/
        OnloadMethod() {
            this.GetTypeList();   //获取记录类型
            this.GetFollowLog();
        },


        /** 其它组件调用当前组件进行数据传递 **/
        BrotherComponentIn(data) {
            if(data.isask) {          //兄弟组件跳转至当前组件时进行询问操作
                this.$confirm.confirm('当前有数据正在执行编辑操作，是否要执行覆盖操作 ？','操作提示',{confirmButtonText:'确定',cancelButtonText:'取消',type: 'warning'}).then(()=> {
                    this.param.shopid=data.id;
                    this.param.shopname=data.shopname;
                    this.param.logo=data.logo;
                    this.param.levelname=data.levelname;
                    this.GetFollowLog();  //获取跟进记录数据
                }).catch(()=> {
                    
                });

            }else if(data.reload) {   //浏览器重新刷新时执行的操作
                
            }else {
                this.param.shopid=data.id;
                this.param.shopname=data.shopname;
                this.param.logo=data.logo;
                this.param.levelname=data.levelname;
                this.GetFollowLog();  //获取跟进记录数据

            } 
        },


        /** 新增记录 **/
        submit() {
            var loadingobj=this.$refs.ShopFollow;
            this.$loading.openloading(loadingobj);  //加载等待动画
            var filelist=[];
            for(var i in this.param.files) filelist.push(this.param.files[i].thumb);
            this.param.files=filelist;

            INTERFACE_MODEL_SHOP.ADD_FOLLOW(this.param).then((res) => {
                this.$loading.closeloading(loadingobj);
                if(res.status > 0) return false;
                this.$notice({title:'成功提示',message:'数据提交成功',type:'success'});
                this.param.typeid='';
                this.param.typename='';
                this.param.description='';
                this.param.followtime='';
                this.param.files=[];
                this.param.list=[];
                this.GetFollowLog();
            });
        },



        /** 获取记录类型 **/
        GetTypeList() {
            INTERFACE_MODEL_SHOP.GET_PLATFORM_FOLLOW_TYPE().then((res) => {
                if(res.status > 0) return false;
                this.typelist=res.data;
            });
        },


        /** 获取跟进记录数据 **/
        GetFollowLog() {
            //loading等待动画加载
            INTERFACE_MODEL_SHOP.GET_PLATFORM_SHOP_FOLLOW({shopid:this.param.shopid}).then((res) => {
                 if(res.status > 0) return false;
                 this.loglist=res.data;
                 for(var i in this.loglist) {
                     this.loglist[i].filelist=[];
                     for(var ii in this.loglist[i].files) {
                         this.loglist[i].filelist.push(this.loglist[i].files[ii].base);
                     }

                 }

            });
        },


        /** 上传图片 **/
        GetFileImges(filelist) {
            this.param.files=[];
            for(var i in filelist) this.param.files.push(filelist[i]);
        },


    },
}
</script>
<style scoped>
.TTL-image-box-large {cursor: pointer;width:auto !important;}
.TTL-image-box-large .el-image {width:120px;height:120px;display: inline-block;border-radius: 5px;}
.TTL-image-box-large span {display: inline-block;font-size:12px;margin-left:20px;color:#f56c6c;}
.TTL-btn-option {display:inline-block;margin-right:20px;}
::v-deep(.TTL-radio .el-radio__label) {display: inline-flex !important;align-items: center !important;}
.TTL-radio .el-image {width:18px;height: 18px;}
.shop-follow-info {display: inline-flex;align-items: center;width:100%;}
.border50 {border-radius: 50%;}
.shop-names {font-size:13px;margin-left:15px;color:#666666;}
.shop-level {font-size:13px;margin-left:10px;color:#666666;}
.TTL-photos {display:inline-block;width:50%;font-size:0;}
.TTL-photos-infos {display:inline-block;width:100px;height:100px;margin-right:10px;margin-bottom:10px;background-color:#e6e7ec;border-radius: 15px;overflow:hidden;position:relative;}
.TTL-photos-infos .el-image {width:100%;height:100%;}
.TTL-photos-del {width:25px;height:25px;position: absolute;top:0;right:0;margin-top:5px;margin-right:5px;border-radius: 50%;background-color: rgba(0,0,0,1);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/close.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.default-photos {background-image:url(@/assets/icon/default-img.png);background-repeat: no-repeat;background-size: 65%;background-position: center;cursor: pointer;}
.TTL-photos-select {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:#666eeb;display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-photos-select-no {width:25px;height:25px;position: absolute;bottom:0;right:0;margin-bottom:5px;margin-right:5px;border-radius: 50%;background-color:rgba(221,221,221,.6);display:inline-flex;justify-content: center;align-items: center;background-image:url(@/assets/icon/right.png);background-repeat: no-repeat;background-size:8px;background-position: center;}
.TTL-form-label i {font-style:normal;color:red;font-size:12px;font-weight: 400;}
.shop-follow-log {position:absolute;width:calc(40% - 40px);height:calc(100% - 40px);padding:40px 20px;top:0;right:0;overflow-y:auto;font-size:0;}
.shop-follow-log::-webkit-scrollbar{width:0;}
.shop-follow-log-info {display:inline-block;padding:10px 20px 10px 20px;width:calc(100% - 40px - 2px);font-size:0;margin-bottom:15px;border-left:2px solid #E6E8EB;position:relative;}
.log-cover {width:15px;height:15px;background-color:#E6E8EB;border-radius: 50%;position:absolute;top:0;left:0;margin-left:-8.5px;margin-top:-7.5px;box-shadow: 0 0 5px #E6E8EB;}

.shop-follow-log-info:first-child {border-left:2px solid #666eeb;}
.shop-follow-log-info:first-child .log-cover {background-color:#666eeb;box-shadow: 0 0 5px #666eeb;}


.shop-follow-times {display:inline-block;width:100%;font-size:13px;}
.shop-follow-times i {position:absolute;right:0;margin-right:30px;font-style: normal;}
.shop-follow-content {font-size:12px;display: inline-block;width:100%;color:#999999;line-height: 18px;letter-spacing: 1px;margin-top:15px;}
.shop-follow-files {display:inline-block;width:100%;margin-top:10px;}
.shop-follow-files .el-image {display:inline-block;width:60px;height: 60px;border-radius: 6px;background-color: #e6e7ec;margin:0 10px 10px 0;cursor: pointer;}
.shop-info-stat {display:inline-block;width:50%;}
.shop-info-stat-info {display: inline-block;width:90px;margin-right:10px;}
.shop-info-stat-info .img {display: inline-block;width:100%;text-align: center;}
.shop-info-stat-info .img .el-image {background-color:#666eeb;width:40%;border-radius: 50%;}
.shop-info-stat-info .title {display: inline-block;width:100%;text-align: center;font-size:12px;letter-spacing: 1px;color:#666666;}
.shop-info-stat-info .content {display: inline-block;width:100%;text-align: center;font-size:13px;font-weight: 800;letter-spacing: 1px;color:#666eeb;}
</style>